module.exports = __webpack_public_path__ + "static/media/card-boosters-bg_mobile.d3aa9cad.svg";